import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { aboutInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-money-cny-circle-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">磁力金牛</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {aboutInfo.brandSlogan}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><Link to="/category/tutorial" className="text-sm text-background-400 hover:text-primary-400 transition-colors">新手教程</Link></li>
              <li><Link to="/category/cases" className="text-sm text-background-400 hover:text-primary-400 transition-colors">成功案例</Link></li>
              <li><Link to="/category/register" className="text-sm text-background-400 hover:text-primary-400 transition-colors">立即注册</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>{aboutInfo.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>{aboutInfo.contact.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>{aboutInfo.contact.address}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                <span>{aboutInfo.contact.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 磁力金牛 版权所有 | 粤ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}